import { PopoverPanel } from '@headlessui/react';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { selectMapStopSelection, useAppSelector } from '../../../redux';
import { SlimDropDownMenu } from '../../common/Dropdowns';
import { ResultSelection } from '../../StopRegistry/Search/Common';
import {
  EquipmentReportMenuItem,
  InfoSpotReportReportMenuItem,
} from '../../StopRegistry/Search/Components/ResultsActionMenuItems';
import { useMapUrlStateContext } from '../Utils/mapUrlState';
import { StopSelectionListing } from './StopSelectionListing';

const testIds = {
  panel: 'Map::StopSelection::panel',
  actionMenu: 'Map::StopSelection::actionMenu',
};

type StopSelectionPanelProps = {
  readonly className?: string;
};

export const StopSelectionPanel: FC<StopSelectionPanelProps> = ({
  className,
}) => {
  const { t } = useTranslation();

  const {
    state: { filters },
  } = useMapUrlStateContext();

  const mapStopSelection = useAppSelector(selectMapStopSelection);
  const reportResultSelection: ResultSelection = useMemo(() => {
    if (
      mapStopSelection.byResultSelection ||
      mapStopSelection.selected.length === 0
    ) {
      return { selectionState: 'NONE_SELECTED', included: [], excluded: [] };
    }

    return {
      selectionState: 'SOME_SELECTED',
      included: mapStopSelection.selected,
      excluded: [],
    };
  }, [mapStopSelection]);

  return (
    <PopoverPanel
      className={twMerge(
        'absolute z-10 w-[350px] rounded-md bg-white shadow-md',
        className,
      )}
      data-testid={testIds.panel}
    >
      <div className="flex items-center justify-between border-b border-light-grey p-2">
        <h4>{t(($) => $.map.stopSelection.title)}</h4>
        <SlimDropDownMenu
          className="text-base"
          buttonText={t(($) => $.map.stopSelection.download)}
          disabled={reportResultSelection.selectionState === 'NONE_SELECTED'}
          testId={testIds.actionMenu}
        >
          <EquipmentReportMenuItem
            filters={filters}
            resultCount={reportResultSelection.included.length}
            resultSelection={reportResultSelection}
          />
          <InfoSpotReportReportMenuItem
            filters={filters}
            resultCount={reportResultSelection.included.length}
            resultSelection={reportResultSelection}
          />
        </SlimDropDownMenu>
      </div>
      <StopSelectionListing />
    </PopoverPanel>
  );
};
